import { render, staticRenderFns } from "./PanelInch75.vue?vue&type=template&id=606ba188&scoped=true&"
import script from "./PanelInch75.vue?vue&type=script&lang=js&"
export * from "./PanelInch75.vue?vue&type=script&lang=js&"
import style0 from "./PanelInch75.vue?vue&type=style&index=0&id=606ba188&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "606ba188",
  null
  
)

export default component.exports